<template>
  <div>
    <titulo-modulo titulo="Atualização Cadastral" />

    <v-list class="mt-4">
      <template v-for="(opcao, i) in opcoes">
        <v-list-item :key="i" link :to="opcao.rota">
          <v-list-item-avatar>
            <v-icon>{{ opcao.icone }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ opcao.descricao }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider
          v-if="i < opcoes.length - 1"
          :key="opcoes.length + i"
        ></v-divider>
      </template>
    </v-list>
  </div>
</template>

<script>
import TituloModulo from "../../components/TituloModulo.vue";
export default {
  components: {
    TituloModulo,
  },
  data: () => ({
    opcoes: [
      {
        icone: "mdi-phone-outline",
        descricao: "Contato",
        rota: "/atualizacao-cadastral/contato",
      },
      {
        icone: "mdi-home-edit-outline",
        descricao: "Endereço",
        rota: "/atualizacao-cadastral/endereco",
      },
      {
        icone: "mdi-clipboard-account-outline",
        descricao: "Dados Pessoais",
        rota: "/atualizacao-cadastral/dados-pessoais",
      },
      {
        icone: "mdi-account-school-outline",
        descricao: "Escolaridade e Cursos",
        rota: "/atualizacao-cadastral/escolaridade",
      },
    ],
  }),
};
</script>
